import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { RouterModule } from '@angular/router';

import { ContextualNotificationComponent } from './components/contextual-notification/contextual-notification.component';
import { IdlePopupComponent } from '@shared/components/idle-popup/idle-popup.component';
import { NotificationComponent } from './components/notification/notification.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { GlobalSearchComponent } from './components/global-search/global-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  DxAutocompleteModule,
  DxDataGridModule,
  DxPopoverModule,
  DxScrollViewModule,
  DxPopupModule,
} from 'devextreme-angular';
import { GlobalSearchListComponent } from './components/global-search-list/global-search-list.component';
import { GahMatDialogComponent } from './components/gah-mat-dialog/gah-mat-dialog.component';
import { AssetCartCheckoutDownloadPopupComponent } from './components/asset-cart-checkout-download-popup/asset-cart-checkout-download-popup';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { GahMatPopupComponent } from './components/gah-mat-popup/gah-mat-popup.component';
import { MatPasswordStrengthComponent } from './components/mat-password-strength/mat-password-strength.component';
import { DynamicBreadcrumbComponent } from './components/dynamic-breadcrumb/dynamic-breadcrumb.component';
import { MaterialModule } from '../material/material.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ContextualNotificationComponent,
    NotificationComponent,
    IdlePopupComponent,
    HeaderComponent,
    FooterComponent,
    GlobalSearchComponent,
    GlobalSearchListComponent,
    GahMatDialogComponent,
    AssetCartCheckoutDownloadPopupComponent,
    GahMatPopupComponent,
    MatPasswordStrengthComponent,
    DynamicBreadcrumbComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgScrollbarModule,
    ReactiveFormsModule,
    FormsModule,
    NgxSpinnerModule,
    DxPopoverModule,
    DxPopupModule,
    DxScrollViewModule,
    DxDataGridModule,
    RouterModule,
    TranslateModule.forChild(),
    DxAutocompleteModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [
    ContextualNotificationComponent,
    NotificationComponent,
    IdlePopupComponent,
    HeaderComponent,
    FooterComponent,
    AssetCartCheckoutDownloadPopupComponent,
    MatPasswordStrengthComponent,
    DynamicBreadcrumbComponent,
  ],
})
export class SharedModule {}
